import { useState, useEffect } from 'react';

/**
 * メディアクエリをReactで使用するためのカスタムフック
 * @param query メディアクエリ文字列
 * @returns メディアクエリにマッチするかどうか
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    
    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // 初期値を設定
    setMatches(mediaQuery.matches);

    // リスナーを追加
    mediaQuery.addEventListener('change', handleChange);

    // クリーンアップ
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
};

/**
 * PC表示かどうかを判定するフック
 * タブレット（768px以上）からPC表示に切り替える
 */
export const useIsDesktop = (): boolean => {
  return useMediaQuery('(min-width: 768px)');
};



